export default [
  {
    path: "/maintenance/products",
    name: "products",
    meta: {
      permissions: {
        roles: ["office", "administrator", "superadmin"],
        redirectTo: "/401"
      },
      title: "ITEMS_TITLE"
    },
    component: () =>
      import(/* webpackChunkName: "ProductView" */ "./ProductView/ProductView.vue")
  },
  {
    path: "/maintenance/locations",
    name: "locations",
    meta: {
      permissions: {
        roles: ["office", "administrator", "superadmin"],
        redirectTo: "/401"
      },
      title: "LOCATIONS_TITLE"
    },
    component: () =>
      import(/* webpackChunkName: "forecasts" */ "./locations/Locations.vue")
  },
  {
      path: "/maintenance/import",
      name: "import",
      meta: {
        permissions: {
          roles: ["office", "administrator", "superadmin"],
          redirectTo: "/401"
        },
        title: "import"
      },
      component: () =>
        import(/* webpackChunkName: "forecasts" */ "./import/ImportExportView.vue")
  },
];
